
import { createApi } from "@reduxjs/toolkit/query/react";
import { transformSucessResponse, transformErrorResponse } from '../../../utils/API/responseMiddleware'
import { transformRequest } from "../../../utils/API/requestMiddleware";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";


const gmapMemberDirectoryListApi = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'GmapMemberDirectoryListApi',
    endpoints: (builder) => ({
        getMemberDirectoryList: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/GetGmapDirectoryList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteMemberDirectory: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/DeleteGMAPDirectory',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    }),
});

export const {
    useGetMemberDirectoryListMutation,
    useDeleteMemberDirectoryMutation,
} = gmapMemberDirectoryListApi;

export default gmapMemberDirectoryListApi;